import React from "react";

interface RadioOption {
  id: string;
  text: string;
}

interface RadioGroupProps {
  label?: string;
  name: string;
  options: RadioOption[];
  selectedValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
  required?: boolean;
  disabled?: boolean;
  error?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  label,
  name,
  options,
  selectedValue,
  onChange,
  required = false,
  disabled = false,
  error,
}) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-yellow-300 mb-1">
          {label} {required && <span className="text-red-400">*</span>}
        </label>
      )}
      <div className="space-y-2">
        {options.map((opt) => (
          <label
            key={opt.id}
            className={`flex items-center gap-3 text-sm rounded px-3 py-2 cursor-pointer transition 
            ${
              disabled
                ? "text-gray-500 cursor-not-allowed"
                : selectedValue === opt.text
                ? "bg-yellow-900/20 border border-yellow-400 text-yellow-100"
                : "hover:bg-gray-700 text-gray-200"
            }`}
          >
            <input
              type="radio"
              name={name}
              value={opt.text}
              checked={selectedValue === opt.text}
              onChange={onChange}
              disabled={disabled}
              className="accent-yellow-400 w-4 h-4 text-sm"
              required={required}
            />
            {opt.text}
          </label>
        ))}
      </div>
      {error && <p className="text-sm text-red-400 mt-1">{error}</p>}
    </div>
  );
};

export default RadioGroup;
